import { PartnersDTO } from "../domain/models/dto/PartnersDTO";
import { IPartners } from "../domain/models/Partners";
import { PartnersModel } from "../models/PartnersModel";
import { FileMapper } from "./FileMapper";
import { PartnersTranslationMapper } from "./PartnersTranslationMapper";
import { SimpleMapper } from "./SimpleMapper";

export class PartnersMapper extends SimpleMapper<IPartners, PartnersDTO> {
    protected toDTOFields: string[] = [
        "id",
        "files",
        "translations",
        "isActive",
        "websiteUrl",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "availableLangs",
        "creatorId",
        "createdAt",
        "updatedAt",
    ];
    protected entityConstructor = PartnersModel;
    private fileMapper = new FileMapper();
    private partnersTranslationMapper = new PartnersTranslationMapper();

    toDTO(model: IPartners): PartnersDTO {
        if (!model) {
            return null;
        }

        const baseDto = super.toDTO(model);

        baseDto.translations =
            model.translations?.map((t) =>
                this.partnersTranslationMapper.toDTO(t)
            ) ?? [];

        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }

    fromDTO(dto: PartnersDTO): IPartners {
        if (!dto) {
            return null;
        }

        const baseModel = super.fromDTO(dto);

        baseModel.translations =
            dto.translations?.map((t) =>
                this.partnersTranslationMapper.fromDTO(t)
            ) ?? [];

        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];

        return baseModel;
    }
}
